import { RequestAction } from '@transcend-io/privacy-types';
import React from 'react';

import AccessIcon from './access.svg';
import EraseIcon from './erase.svg';
import ObjectIcon from './object.svg';
import RestrictIcon from './restrict.svg';
import UpdateIcon from './update.svg';

/**
 * Lookup icon for each type
 */
export const LOOKUP_ICON: { [type in RequestAction]: typeof AccessIcon } = {
  [RequestAction.Access]: AccessIcon,
  [RequestAction.Rectification]: UpdateIcon,
  [RequestAction.Erasure]: EraseIcon,
  [RequestAction.Restriction]: RestrictIcon,
  [RequestAction.AutomatedDecisionMakingOptOut]: ObjectIcon,
  [RequestAction.ContactOptOut]: ObjectIcon,
  [RequestAction.ContactOptIn]: ObjectIcon,
  [RequestAction.TrackingOptOut]: ObjectIcon,
  [RequestAction.SaleOptOut]: ObjectIcon,
  [RequestAction.TrackingOptIn]: ObjectIcon,
  [RequestAction.SaleOptIn]: ObjectIcon,
  [RequestAction.AutomatedDecisionMakingOptIn]: ObjectIcon,
  [RequestAction.CustomOptIn]: ObjectIcon,
  [RequestAction.CustomOptOut]: ObjectIcon,
  [RequestAction.UseOfSensitiveInformationOptIn]: ObjectIcon,
  [RequestAction.UseOfSensitiveInformationOptOut]: ObjectIcon,
  [RequestAction.BusinessPurpose]: ObjectIcon,
  [RequestAction.PlaceOnLegalHold]: ObjectIcon,
  [RequestAction.RemoveFromLegalHold]: ObjectIcon,
};

/**
 * Props
 */
export interface DsrActionIconProps {
  /** Primary color (used on the accent parts of the icon) */
  primaryColor: string;
  /** Selected color (used when the icon is selected) */
  selectedColor: string;
  /** The type of the DSR */
  type: RequestAction;
  /** HTML role */
  role: string;
  /** Should the icon show a selected state? */
  selected?: boolean;
}

/**
 * A DSR Icon
 */
export const DSRIcon: React.FC<DsrActionIconProps> = ({
  type,
  ...svgProps
}) => {
  const Icon = LOOKUP_ICON[type];
  return <Icon {...svgProps} />;
};
